import { render, staticRenderFns } from "./ClosedPage.vue?vue&type=template&id=bd6a3a3e"
import script from "./ClosedPage.vue?vue&type=script&lang=ts"
export * from "./ClosedPage.vue?vue&type=script&lang=ts"
import style0 from "./ClosedPage.vue?vue&type=style&index=0&id=bd6a3a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports